/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BillingSubscription } from './BillingSubscription';
import {
    BillingSubscriptionFromJSON,
    BillingSubscriptionFromJSONTyped,
    BillingSubscriptionToJSON,
    BillingSubscriptionToJSONTyped,
} from './BillingSubscription';

/**
 * 
 * @export
 * @interface CancelBillingSubscriptionResponse
 */
export interface CancelBillingSubscriptionResponse {
    /**
     * 
     * @type {BillingSubscription}
     * @memberof CancelBillingSubscriptionResponse
     */
    data: BillingSubscription;
}

/**
 * Check if a given object implements the CancelBillingSubscriptionResponse interface.
 */
export function instanceOfCancelBillingSubscriptionResponse(value: object): value is CancelBillingSubscriptionResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function CancelBillingSubscriptionResponseFromJSON(json: any): CancelBillingSubscriptionResponse {
    return CancelBillingSubscriptionResponseFromJSONTyped(json, false);
}

export function CancelBillingSubscriptionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CancelBillingSubscriptionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': BillingSubscriptionFromJSON(json['data']),
    };
}

  export function CancelBillingSubscriptionResponseToJSON(json: any): CancelBillingSubscriptionResponse {
      return CancelBillingSubscriptionResponseToJSONTyped(json, false);
  }

  export function CancelBillingSubscriptionResponseToJSONTyped(value?: CancelBillingSubscriptionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': BillingSubscriptionToJSON(value['data']),
    };
}

